import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'who_performs_the_clockinclockout_function_for_wrkrs_select_all'

export const dataPointDefinition = {
  retracedId: 'who_performs_the_clockinclockout_function_for_wrkrs_select_all',
  name: 'Who performs the clock-in/clock-out function for workers?',
  description:
    'The intent of this question is to understand WHO is actually recording the working hours. In other words, who is clocking workers in and out. \r\r\n\r\r\nFor example, if workers usually clock themselves in, but sometimes security also clocks workers in, the selection both should be both: \r\r\n\r\r\n- The individual worker \r\r\n- Security',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THE_INDIVIDUAL_WORKER',
      text: 'The individual worker',
      externalIds: [
        {
          id: 'wh-2-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MANAGEMENT',
      text: 'Management',
      externalIds: [
        {
          id: 'wh-2-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe in what circumstances management performs this function:',
        externalIds: [
          {
            id: 'wh-2-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SECURITY',
      text: 'Security',
      externalIds: [
        {
          id: 'wh-2-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe in what circumstances security performs this function:',
        externalIds: [
          {
            id: 'wh-2-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wh-2-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wh-2-4f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['THE_INDIVIDUAL_WORKER', 'MANAGEMENT', 'SECURITY', 'OTHER'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6410,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
